import React from "react"
import { getLayoutData, getPages } from "../api/api"
import { getNestedPropSafely, getPropSafely } from "@repo/utils"
import { FRAGMENTS } from "@repo/ui/lib"
import { DESIGN_FRAGMENTS, DESIGN_TYPES } from "@/lib"
import dynamic from "next/dynamic"
import dynamicWithLoader from "@repo/ui/src/components/common/DynamicWithLoader"
import VideoBanner from "@repo/ui/src/components/Banners/VideoBanner"

const StickyHeading = dynamic(() => import("@repo/ui/src/components/StickyHeading"), {
	ssr: false,
})

const Projects = dynamicWithLoader(() => import("@repo/ui/src/components/Projects/index"))

const query = `
	query GetAllProjectsPageData($locale: SiteLocale) {
		designAllProjectsPage(locale: $locale) {
			title
			name
			slug
			${FRAGMENTS.SEO_META_FRAGMENT}
			banner {
                header{
                text
                breaks{
                  image{
                    ${FRAGMENTS.IMAGE_FRAGMENT}
                  }
                }
              }
			  text{
				${FRAGMENTS.TEXT_WITH_BREAKS_FRAGMENT}
			  }
			  variant
			}
			video {
				horizontal{
				  ${FRAGMENTS.VIDEO_FRAGMENT}
				}
				vertical{
				  ${FRAGMENTS.VIDEO_FRAGMENT}
				}
		  	}
		  	
		  	${DESIGN_FRAGMENTS.DESCRIPTION_SLOGAN_FRAGMENT}
			${FRAGMENTS.THEME_FRAGMENT}
			${FRAGMENTS.FILTERS_FRAGMENT}
			
			content {
				__typename
				${DESIGN_FRAGMENTS.PROJECTS_GRID_FRAGMENT}
				${DESIGN_FRAGMENTS.SINGLE_PROJECT_FRAGMENT}
				${FRAGMENTS.HORIZONTAL_HEADER_MODULE_FRAGMENT}
			}
			checkothers {
			  	${DESIGN_FRAGMENTS.CHECK_OTHERS_FRAGMENT}
			}
			${FRAGMENTS.PROJECTS_TABLE_FRAGMENT}
		}
	}
`

export default function ProjectsPage({ data }) {
	const content = getPropSafely(data, "content", [])
	const checkOthers = getPropSafely(data, "checkothers", {})
	const filters = getPropSafely(data, "filters", [])
	const videoBanner = { banner: getPropSafely(data, "banner", {}), video: getPropSafely(data, "video", {}) }
	const desc = {
		slogan: [
			getNestedPropSafely(data, ["descriptionSlogan"], "slogan1", ""),
			getNestedPropSafely(data, ["descriptionSlogan"], "slogan2", ""),
		],
		button: getNestedPropSafely(data, ["descriptionSlogan"], "button", {}),
		description: getNestedPropSafely(data, ["descriptionSlogan"], "description", {}),
	}
	const projectsTable = getPropSafely(data, "projectsTable", [])
	return (
		<>
			<StickyHeading stickyHeadingsSelectors={[]} />
			<VideoBanner data={videoBanner} webGL />
			<Projects
				data={content}
				filters={filters}
				desc={desc}
				checkOthers={checkOthers}
				types={DESIGN_TYPES}
				projectsTable={projectsTable}
				webGL
			/>
		</>
	)
}

export async function getStaticProps(context) {
	const locale = context?.locale || "pl"
	const data = await getPages("designAllProjectsPage", query, locale)
	const { globals, cookies, footer, menu } = await getLayoutData(locale)
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			footer,
			menu,
		},
		revalidate: 120,
	}
}
